// Deep snake_case → camelCase key normalizer.
//
// The procurement backend emits snake_case fields per the BA spec / CLAUDE.md
// (`allowed_actions`, `or_code`, `budget_context`, `is_selected`,
// `remaining_after_this_order`, …), while the FE components + JSDoc types speak
// camelCase (`allowedActions`, `orCode`, `budgetContext`, …). The axios base
// query returns the raw body with no transform, so without this the manager
// approval screens read `undefined` for every multi-word field — the decision
// buttons (driven entirely by `allowedActions`) never render.
//
// Applied as an RTK Query `transformResponse` on the real `/private/procurement`
// read endpoints. It only rewrites keys that actually contain an underscore, so
// it is idempotent for keys that are already camelCase — safe even if a given
// endpoint one day returns camelCase directly.

const snakeToCamel = (key) =>
  key.includes("_")
    ? key.replace(/_([a-z0-9])/g, (_m, c) => c.toUpperCase())
    : key

// Only plain objects (and arrays) have their keys rewritten. Dates, class
// instances, null, and primitives pass through untouched so we never corrupt a
// value while normalizing its container.
const isPlainObject = (v) =>
  v !== null &&
  typeof v === "object" &&
  (v.constructor === Object || v.constructor === undefined)

export const camelizeKeys = (input) => {
  if (Array.isArray(input)) return input.map(camelizeKeys)
  if (!isPlainObject(input)) return input

  const out = {}
  for (const [key, value] of Object.entries(input)) {
    out[snakeToCamel(key)] = camelizeKeys(value)
  }
  return out
}

export default camelizeKeys
